import heroList from "../data/heroList.json";

export const normalizeHeroKey = (name = "") =>
  String(name || "").trim().toLowerCase().replace(/[^a-z0-9]/g, "");

const HERO_ITEMS = Array.isArray(heroList) ? heroList : heroList?.heroes || [];

const HERO_BY_KEY = new Map(
  HERO_ITEMS
    .filter((hero) => hero?.name)
    .map((hero) => [normalizeHeroKey(hero.name), hero])
);

const FLOWBORN_NAME_BY_KEY = new Map([
  ["flowborncarry", "Flowborn Carry"],
  ["flowbornadc", "Flowborn Carry"],
  ["flowbornad", "Flowborn Carry"],
  ["flowbornmarksman", "Flowborn Carry"],
  ["flowbornmage", "Flowborn Mage"],
  ["flowbornmid", "Flowborn Mage"],
]);

// ชีทเขียน "Flowborn" เฉยๆ ทั้งสายยิงและสายเวท (ADL 1044 เกม / MID 300 / JUG 35)
// ชื่อยังเป็น "Flowborn" เหมือนเดิม แต่รูปเลือกตามตำแหน่งได้ถ้ารู้ ไม่รู้ก็ใช้สายยิง
const ROLE_IMAGE_VARIANTS = new Map([
  [
    "flowborn",
    { ADL: "flowborn-carry.jpg", MID: "flowborn-mage.jpg", DEFAULT: "flowborn-carry.jpg" },
  ],
]);

function imageRoleToken(role = "") {
  const s = String(role || "").toUpperCase();
  if (/ADL|ADC|CARRY/.test(s)) return "ADL";
  if (/MID|MAGE/.test(s)) return "MID";
  return "";
}

export function canonicalHeroName(name = "") {
  const raw = String(name || "").trim().replace(/\s+/g, " ");
  if (!raw) return "";

  const key = normalizeHeroKey(raw);
  const knownFlowborn = FLOWBORN_NAME_BY_KEY.get(key);
  if (knownFlowborn) return knownFlowborn;

  return HERO_BY_KEY.get(key)?.name || raw;
}

export function heroBlockKey(name = "") {
  return normalizeHeroKey(canonicalHeroName(name));
}

export function getHeroImageUrl(heroName, role = "") {
  const canonical = canonicalHeroName(heroName);
  const key = normalizeHeroKey(canonical);
  const variants = ROLE_IMAGE_VARIANTS.get(key);
  const file = variants
    ? variants[imageRoleToken(role)] || variants.DEFAULT
    : HERO_BY_KEY.get(key)?.image;
  return file ? `${process.env.PUBLIC_URL}/heroimages/${file}` : null;
}

export function getHeroImageUrlWithFallback(heroName, role = "") {
  const fromCatalog = getHeroImageUrl(heroName, role);
  if (fromCatalog) return fromCatalog;

  const file = canonicalHeroName(heroName)
    .toLowerCase()
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, "-")
    .replace(/[^\w-]/g, "")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");

  return file
    ? `${process.env.PUBLIC_URL}/heroimages/${file}.jpg`
    : `${process.env.PUBLIC_URL}/heroimages/default.jpg`;
}
